module.exports = __webpack_public_path__ + "static/media/paige-wu.5b76c559.png";